var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "actions is-centered" },
    [
      _c(
        "AppRadialMenu",
        {
          attrs: {
            size: 36,
            "item-size": 48,
            radius: 80,
            "angle-restriction": 180,
            rotate: 270
          }
        },
        [
          _c(
            "AppRadialMenuItem",
            {
              staticClass:
                "tooltip is-tooltip-primary has-background-primary has-text-white",
              attrs: { "data-tooltip": "Detalle de auto factura" }
            },
            [
              _c(
                "RouterLink",
                {
                  staticClass: "action-option",
                  attrs: {
                    to: { name: "InvoiceDetail", params: { uuid: _vm.id } }
                  }
                },
                [
                  _c("BIcon", {
                    staticClass: "action-option-icon",
                    attrs: { icon: "eye" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "AppRadialMenuItem",
            {
              staticClass:
                "tooltip is-tooltip-success has-background-success has-text-white",
              attrs: { "data-tooltip": "Regenerar PDF" }
            },
            [
              _c(
                "a",
                {
                  staticClass: "action-option",
                  on: {
                    click: function($event) {
                      return _vm.regeneratePdf("pdf", _vm.invoice)
                    }
                  }
                },
                [
                  _c("BIcon", {
                    staticClass: "action-option-icon",
                    attrs: { icon: "autorenew" }
                  }),
                  _c("span", { staticClass: "close-label" }, [
                    _vm._v("\n          pdf\n        ")
                  ])
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }